export default {
  data() {
    return {
      newClientStateOptions: [
        { value: 'AL', text: 'Alabama' },
        { value: 'AK', text: 'Alaska' },
        { value: 'AZ', text: 'Arizona' },
        { value: 'AR', text: 'Arkansas' },
        { value: 'CA', text: 'California' },
        { value: 'CO', text: 'Colorado' },
        { value: 'CT', text: 'Connecticut' },
        { value: 'DC', text: 'District of Columbia' },
        { value: 'DE', text: 'Delaware' },
        { value: 'FL', text: 'Florida' },
        { value: 'GA', text: 'Georgia' },
        { value: 'HI', text: 'Hawaii' },
        { value: 'ID', text: 'Idaho' },
        { value: 'IL', text: 'Illinois' },
        { value: 'IN', text: 'Indiana' },
        { value: 'IA', text: 'Iowa' },
        { value: 'KS', text: 'Kansas' },
        { value: 'KY', text: 'Kentucky' },
        { value: 'LA', text: 'Louisiana' },
        { value: 'ME', text: 'Maine' },
        { value: 'MD', text: 'Maryland' },
        { value: 'MA', text: 'Massachusetts' },
        { value: 'MI', text: 'Michigan' },
        { value: 'MN', text: 'Minnesota' },
        { value: 'MS', text: 'Mississippi' },
        { value: 'MO', text: 'Missouri' },
        { value: 'MT', text: 'Montana' },
        { value: 'NE', text: 'Nebraska' },
        { value: 'NV', text: 'Nevada' },
        { value: 'NH', text: 'New Hampshire' },
        { value: 'NJ', text: 'New Jersey' },
        { value: 'NM', text: 'New Mexico' },
        { value: 'NY', text: 'New York' },
        { value: 'NC', text: 'North Carolina' },
        { value: 'ND', text: 'North Dakota' },
        { value: 'OH', text: 'Ohio' },
        { value: 'OK', text: 'Oklahoma' },
        { value: 'OR', text: 'Oregon' },
        { value: 'PA', text: 'Pennsylvania' },
        { value: 'PR', text: 'Puerto Rico' },
        { value: 'RI', text: 'Rhode Island' },
        { value: 'SC', text: 'South Carolina' },
        { value: 'SD', text: 'South Dakota' },
        { value: 'TN', text: 'Tennessee' },
        { value: 'TX', text: 'Texas' },
        { value: 'UT', text: 'Utah' },
        { value: 'VT', text: 'Vermont' },
        { value: 'VA', text: 'Virginia' },
        { value: 'WA', text: 'Washington' },
        { value: 'WV', text: 'West Virginia' },
        { value: 'WI', text: 'Wisconsin' },
        { value: 'WY', text: 'Wyoming' }
      ],
      yesNoOptions: [
        { value: 'Y', text: 'Yes' },
        { value: 'N', text: 'No' }
      ],
      businessTypeOptions: [
        { value: 'CO', text: 'Corporation' },
        { value: 'ME', text: 'MEWA' },
        { value: 'PE', text: 'PEO' },
        { value: 'PR', text: 'Proprietorship' },
        { value: 'TR', text: 'Trust' },
        { value: 'UN', text: 'Union' },
        { value: 'OT', text: 'Other' }
      ],
      serviceAreaOptions: [
        { value: 'NP', text: 'National (U.S.– does not include Puerto Rico)' },
        { value: 'IP', text: 'National (U.S.– does include Puerto Rico)' },
        { value: 'SS', text: 'State Specific.' }
      ],
      initialMembershipFormatOptions: [
        { value: 'EF', text: 'Electronic File Feed (HIPAA 834)' },
        { value: 'DE', text: 'Employee Navigator Data Exchange (Brokers Only)' },
        { value: 'EX', text: 'EyeMed Excel Format – File Feed' },
        { value: 'OL', text: 'EyeMed Excel Format – One-time Load Only' },
        { value: 'EM', text: 'EyeManage - Group enters online' }
      ],
      ongoingMembershipFormatOptions: [
        { value: 'EF', text: 'Electronic File Feed (HIPAA 834)' },
        { value: 'DE', text: 'Employee Navigator Data Exchange (Brokers Only)' },
        { value: 'EX', text: 'EyeMed Excel Format – File Feed' },
        { value: 'EM', text: 'EyeManage - Group enters online' }
      ],
      fileSenderOptions: [
        { value: 'broker', text: 'Broker' },
        { value: 'client', text: 'Client' },
        { value: 'TPA', text: 'Third Party Administrator (TPA)' }
      ],
      membershipCobraOptions: [
        { value: 'Y', text: 'Yes' },
        { value: 'N', text: 'No, COBRA sent separately' },
        { value: 'O', text: 'COBRA not offered' }
      ],
      categoryOptions: [
        { value: '1', text: 'category1' },
        { value: '2', text: 'category2' },
        { value: '3', text: 'category3' }
      ]
    }
  },
  methods: {

  },
  computed: {

  },
  created() {

  }
}
